import { SelectedProductInterface } from 'domains/Catalog/Products/components';
import { SimpleProductType } from './types';

export const convertToSelectedProduct = (
  product: SimpleProductType,
): SelectedProductInterface => ({
  id: product.id,
  name: product.name,
  imageUrl: product.imageUrl,
  stock: false,
  visible: true,
  attributes: [],
  variants: [],
});

export const initialValues = {
  name: '',
  taxRate: null,
  products: [] as SimpleProductType[],
};
